(function () {
  var DEBOUNCE_DELAY = 75;
  var RETRY_DELAY = 150;
  var debounceTimer;

  function notifyBSS() {
    BSS_B2B.observer.cartSubject.notifyObserver('CartMutate', 'CartPriceMutate');
  }

  function onHulkPriceChanged() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(notifyBSS, DEBOUNCE_DELAY);
  }

  function watchHulkPrice() {
    var priceEl = document.querySelector('[data-hulkapps-cart-total]');
    if (!priceEl) return;

    new MutationObserver(onHulkPriceChanged).observe(priceEl, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  function init() {
    if (typeof BSS_B2B === 'undefined' || !BSS_B2B.observer?.cartSubject?.notifyObserver) {
      setTimeout(init, RETRY_DELAY);
      return;
    }
    watchHulkPrice();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();